import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_grids2d_set_current_cell } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell';
import { LOCAL__ui_grids2d_set_current_cell_neigbours } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell_neigbours';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { FN_GRID2D_GALLERY_GENERATION__set_cell_current } from './FN_GRID2D_GALLERY_GENERATION__set_cell_current';

interface PROPS {
  grid2d: DTO__grid2d;
}

export function WATCHER_GRID2D_GALLERY_GENERATION__cell_current_set({ grid2d }: PROPS) {
  const dispatch = use_dispatch();
  const { global__grid2d_gallery_cell_current, global__grid2d_show_as_gallery } = use_slice_ui([
    'global__grid2d_gallery_cell_current',
    'global__grid2d_show_as_gallery',
  ]);

  /*
   *
   */

  use_effect(() => {
    try_set_current_cell();

    return () => {
      if (global__grid2d_gallery_cell_current._id == grid2d._id) {
        cleanup_current_cell();
      }
    };
  }, [global__grid2d_show_as_gallery, grid2d]);

  function try_set_current_cell() {
    if (global__grid2d_gallery_cell_current.grid2d_id != grid2d._id) {
      //set 1st cell
      try_set_current_cell_with_content_or_0x0();
    } else {
      //update cell current
      assert_instanceof(grid2d, DTO__grid2d_generation);
      assert_instanceof(global__grid2d_gallery_cell_current, DTO__grid2d_cell_generation);

      let chunk = grid2d.get_generation_chunk();

      let cell = chunk.get_cell_by_coordinates(global__grid2d_gallery_cell_current.x, global__grid2d_gallery_cell_current.y);

      FN_GRID2D_GALLERY_GENERATION__set_cell_current(grid2d, cell);
    }
  }

  function try_set_current_cell_with_content_or_0x0() {
    assert_instanceof(grid2d, DTO__grid2d_generation);

    let chunk = grid2d.get_generation_chunk();

    //try get first with content
    let cell = chunk.cells_list.find_or_default(cell => !cell.hash_sha256_content.is_empty_hash_sha256(), DTO__grid2d_cell_generation.CREATE_STUB());

    //fallback to 0x0
    if (cell.hash_sha256_content.is_empty_hash_sha256()) {
      cell = chunk.get_cell_by_coordinates(0, 0);
    }

    FN_GRID2D_GALLERY_GENERATION__set_cell_current(grid2d, cell);
  }

  function cleanup_current_cell() {
    dispatch(LOCAL__ui_grids2d_set_current_cell(DTO__grid2d_cell.CREATE_STUB()));

    dispatch(LOCAL__ui_grids2d_set_current_cell_neigbours([]));
  }

  return null;
}
